import React, {useEffect} from 'react'
import BorderedDisplay from "../Shared/UiKit/BorderedDisplay";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import useDebounceV2 from "../Hooks/useDebounceV2";
import {Filter} from "../Shared/FilterHelper";
import MedicalEventStore from "./MedicalEventStore";
import {toast} from "react-toastify";

const AddExistingPatient = () => {
    const [patients, setPatients] = React.useState([])
    const [patient, setPatient] = React.useState(null)
    const debouncedGetPatients = useDebounceV2((filter) => getPatients(filter), 500)

    const getPatients = (filter = undefined) => {
        MedicalEventStore.getAvailablePatients(filter).then(patients => {
            setPatients(patients)
        })
    }

    const addPatient = () => {
        MedicalEventStore.addPatient(patient).then(_ => {
            setPatient(null)
        }).catch(_ => toast.error("Erreur lors de l'ajout du patient"))
    }

    return <BorderedDisplay text={"Ajouter un patient existant"}>
        <div className="fr" style={{justifyContent: "space-between"}}>
            <Autocomplete
                sx={{width: 500}}
                disablePortal
                filterSelectedOptions
                className="ui-autocomplete"
                value={patient}
                options={(patients ?? [])}
                getOptionLabel={(patient) => `${Helper.formatName(patient.prenom, patient.nom)}`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, value) => setPatient(value)}
                onInputChange={(_, value) => debouncedGetPatients({nom_prenom_email: {[Filter.CONTAINS_ALL_CASE_INSENSITIVE]: value.split(" ")}})}
                renderInput={(params) => <TextField {...params} label="Rechercher patient"/>}
            />
            <a className={`btn small blue darken-2 z-depth-0 ${patient ?? "disabled"}`} onClick={addPatient}>
                <i className="material-icons left">add</i>
                Ajouter
            </a>
        </div>
    </BorderedDisplay>
}

export default AddExistingPatient